export default __webpack_public_path__ + "static/media/revertirCancelacion.6737b2ac.svg";